import React from 'react'
import './Loader1.css';

const Loader1 = () => {
    return (
        <>
            <div class="loader1"></div>
        </>
    )
}

export default Loader1
